import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const analyticsApi = createApi({
    reducerPath: 'analyticsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api/analytics`,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    keepUnusedDataFor: 300, // 5 minutes cache
    tagTypes: ['Analytics'],
    endpoints: (build) => ({
        getAnalyticsOverview: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/overview?${qs}` : '/overview';
            },
            providesTags: ['Analytics'],
        }),
        getTrafficSources: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/traffic-sources?${qs}` : '/traffic-sources';
            },
            providesTags: ['Analytics'],
        }),
        getPageViews: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/page-views?${qs}` : '/page-views';
            },
            providesTags: ['Analytics'],
        }),
        getUserAcquisition: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/user-acquisition?${qs}` : '/user-acquisition';
            },
            providesTags: ['Analytics'],
        }),
        getDeviceBreakdown: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/device-breakdown?${qs}` : '/device-breakdown';
            },
            providesTags: ['Analytics'],
        }),
        getGeography: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/geography?${qs}` : '/geography';
            },
            providesTags: ['Analytics'],
        }),
        getGeographyCountries: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/geography/countries?${qs}` : '/geography/countries';
            },
            providesTags: ['Analytics'],
        }),
        getRealTimeUsers: build.query({
            query: () => '/real-time',
            providesTags: ['Analytics'],
        }),
        getConversionFunnel: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/conversion-funnel?${qs}` : '/conversion-funnel';
            },
            providesTags: ['Analytics'],
        }),
        getUserTrends: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/user-trends?${qs}` : '/user-trends';
            },
            providesTags: ['Analytics'],
        }),
        getNewVsReturning: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/new-vs-returning?${qs}` : '/new-vs-returning';
            },
            providesTags: ['Analytics'],
        }),
        getSessionsByHour: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/sessions-by-hour?${qs}` : '/sessions-by-hour';
            },
            providesTags: ['Analytics'],
        }),
        getLandingPages: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/landing-pages?${qs}` : '/landing-pages';
            },
            providesTags: ['Analytics'],
        }),
        getEngagementStats: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/engagement?${qs}` : '/engagement';
            },
            providesTags: ['Analytics'],
        }),
        getTopListingPages: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/top-listing-pages?${qs}` : '/top-listing-pages';
            },
            providesTags: ['Analytics'],
        }),
        getSessionsByDay: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/sessions-by-day?${qs}` : '/sessions-by-day';
            },
            providesTags: ['Analytics'],
        }),
        getGeographicAudience: build.query({
            query: (params = {}) => {
                const qs = new URLSearchParams(params).toString();
                return qs ? `/geographic-audience?${qs}` : '/geographic-audience';
            },
            providesTags: ['Analytics'],
        }),
    }),
});

export const {
    useGetAnalyticsOverviewQuery,
    useGetTrafficSourcesQuery,
    useGetPageViewsQuery,
    useGetUserAcquisitionQuery,
    useGetDeviceBreakdownQuery,
    useGetGeographyQuery,
    useGetGeographyCountriesQuery,
    useGetRealTimeUsersQuery,
    useGetConversionFunnelQuery,
    useGetUserTrendsQuery,
    useGetNewVsReturningQuery,
    useGetSessionsByHourQuery,
    useGetLandingPagesQuery,
    useGetEngagementStatsQuery,
    useGetTopListingPagesQuery,
    useGetSessionsByDayQuery,
    useGetGeographicAudienceQuery,
} = analyticsApi;
